import { render, staticRenderFns } from "./EditWarehouseComponent.vue?vue&type=template&id=6a4e1f4f"
import script from "./EditWarehouseComponent.vue?vue&type=script&lang=js"
export * from "./EditWarehouseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports